import type { Stage } from '../../types';

export const postpartumLate: Stage = {
  id: 'postpartum-late',
  key: '6',
  title: '産後3–12ヶ月',
  subtitle: '新しい日常を楽しむ',
  weeks: '産後3–12ヶ月',
  description:
    '赤ちゃんの成長が目覚ましい時期です。ママ自身の回復と、夫婦の時間を取り戻しながら、次のステップへ進みましょう。',
  mindCards: [
    {
      id: 'm1',
      title: '今日ができたこと',
      body: '完璧ではなく、今日できたことを小さく認めてあげましょう。',
      type: 'mind',
    },
    {
      id: 'm2',
      title: '自分の回復を見る',
      body: '無理のない運動を再開し、骨盤や体幹のケアを続けましょう。',
      type: 'body',
    },
    {
      id: 'm3',
      title: '離乳食や予防接種を計画に',
      body: '6ヶ月・9ヶ月・1歳の健診と予防接種を計画的に進めます。',
      type: 'life',
    },
    {
      id: 'm4',
      title: '夫婦の時間を取り戻す',
      body: 'パートナーとのつながりを大事に、短くても話す時間を作りましょう。',
      type: 'mind',
    },
    {
      id: 'm5',
      title: '育児と仕事の調整',
      body: '復職や保育園の準備を進め、自分らしい働き方を見つけましょう。',
      type: 'life',
    },
    {
      id: 'm6',
      title: 'パートナー役割を再調整',
      body: '成長に合わせて家事・育児の分担を見直し、二人で支え合いましょう。',
      type: 'partner',
    },
    {
      id: 'm7',
      title: '地域の遊び場へ',
      body: '子育て支援センターや公園で外の刺激とママ友のつながりを。新潟市ではSKIPの遊び場マップも便利です。',
      type: 'life',
    },
    {
      id: 'm8',
      title: '一人で抱え込まない',
      body: 'ファミサポや一時預かりなど、頼れる仕組みを知っておくだけで心が軽くなります。',
      type: 'mind',
    },
  ],
  checklist: [
    { id: 'c1', text: '乳児一般健診（3〜4ヶ月・10ヶ月）と1歳6ヶ月健診を予約する', category: 'hospital', note: '身体測定・発達確認・離乳食相談。新潟市の例。自治体により日程が異なります。' },
    { id: 'c2', text: '離乳食開始の準備をする', category: 'life', note: '5〜6ヶ月頃から。10倍がゆなどなめらかにすりつぶした状態から' },
    { id: 'c3', text: '予防接種の進捗を確認する', category: 'hospital', note: 'BCG・ロタ・Hib・肺炎球菌など。母子手帳のスケジュールを確認' },
    { id: 'c4', text: '扶養控除・税務手続きを確認する', category: 'admin', note: '年末調整や確定申告で必要な書類を確認' },
    { id: 'c5', text: '育休からの復帰準備を進める', category: 'admin', note: '勤務形態・保育園の送迎時間を調整。パパママ育休プラスも確認' },
    { id: 'c6', text: '保育園申込み・見学を計画する', category: 'admin', note: '申込み時期や入所基準を自治体HPで確認。新潟市はSKIPパンフも参考に' },
    { id: 'c7', text: 'ママと赤ちゃんの歯科健診を予約する', category: 'hospital', note: '乳歯が生え始めたら歯科受診を' },
    { id: 'c8', text: '無理のない運動を再開する', category: 'body', note: '骨盤底筋・軽いストレッチから' },
    { id: 'c9', text: '自分の趣味や時間を少しずつ復活させる', category: 'mind', note: '短時間でも自分の時間を作る' },
    { id: 'c10', text: '夫婦で話す時間を作る', category: 'partner', note: '育児以外の話題も意識する' },
    { id: 'c11', text: '骨盤・体幹のケアを続ける', category: 'body', note: '産後の体型は急がず、継続して' },
    { id: 'c12', text: '産後うつ相談先を覚えておく（一般名で）', category: 'mind', note: '精神科・心療内科・各区のこども家庭センターなど' },
    { id: 'c13', text: '地域子育て支援センターを利用する', category: 'mind', note: '新潟市の例：ちゅうりっぷ・あいあい等。遊びと親同士の交流・相談' },
    { id: 'c14', text: 'パートナーと役割分担を見直す', category: 'partner', note: '離乳食・沐浴・夜間対応など' },
    { id: 'c15', text: 'お宮参りや行事の準備を整える', category: 'life', note: '服装・日程・お守りなど' },
    { id: 'c16', text: 'ベビーサインや言葉の発達を楽しむ', category: 'life', note: 'おしゃべりや絵本を通じて' },
    { id: 'c17', text: '災害時の備えを見直す', category: 'life', note: '非常用ミルク・おむつ・連絡先' },
    { id: 'c18', text: 'ママ自身の人間関係を大切にする', category: 'mind', note: '友人や同世代ママとの交流' },
    { id: 'c19', text: '成長に合わせたおもちゃや環境を整える', category: 'shopping', note: '安全基準を確認。誤飲・転落・SIDS予防も' },
    { id: 'c20', text: '二人目以降の計画を話す（必要なら）', category: 'partner', note: '時期や体調、生活設計を共有' },
    { id: 'c21', text: 'こども医療費助成の受給を継続確認する', category: 'admin', note: '新潟市の例。転居や保険変更時は届出を' },
    { id: 'c22', text: 'ファミリー・サポート・センターを調べる', category: 'admin', note: '新潟市の例。送迎・預かりなど有償ボランティア' },
    { id: 'c23', text: '一時預かり・ショートステイを確認する', category: 'admin', note: 'リフレッシュや急用時に。施設により生後数ヶ月から利用可' },
    { id: 'c24', text: '新潟県こむすび定期の申請期限を確認する', category: 'admin', note: '新潟県内出生の1歳未満が対象。1歳の誕生日前日まで' },
    { id: 'c25', text: 'かかりつけ小児科と#8000を確認する', category: 'hospital', note: '休日・夜間はこども医療電話相談#8000（新潟市などの例）' },
    { id: 'c26', text: 'ハチミツを1歳未満に与えない', category: 'body', note: '乳児ボツリヌス症予防。加工品の原材料表示も確認' },
  ],
  shopping: [
    {
      id: 's1',
      name: '離乳食セット（食器・スプーン・エプロン）',
      priority: 'should',
      timing: '5〜6ヶ月頃',
      priceYenMin: 2000,
      priceYenMax: 8000,
      note: '吸盤付きボウルやシリコンスプーンが便利',
    },
    {
      id: 's2',
      name: 'ベビーチェア',
      priority: 'should',
      timing: '5〜6ヶ月頃',
      priceYenMin: 5000,
      priceYenMax: 25000,
      note: '離乳食や家族の食卓に',
    },
    {
      id: 's3',
      name: '赤ちゃんのおもちゃ',
      priority: 'nice',
      timing: '3〜12ヶ月',
      priceYenMin: 1000,
      priceYenMax: 5000,
      note: '音のなるものや布製の布えほんなど',
    },
    {
      id: 's4',
      name: 'ベビーカー対応（買い替え候補）',
      priority: 'nice',
      timing: '3〜12ヶ月',
      priceYenMin: 20000,
      priceYenMax: 60000,
      note: '座れるようになったら切り替え検討',
    },
    {
      id: 's5',
      name: 'ママ用運動ウェア',
      priority: 'nice',
      timing: '3〜12ヶ月',
      priceYenMin: 3000,
      priceYenMax: 10000,
      note: '無理のない運動を始める際に',
    },
    {
      id: 's6',
      name: '育児グッズ収納',
      priority: 'nice',
      timing: '3〜12ヶ月',
      priceYenMin: 2000,
      priceYenMax: 8000,
      note: 'おもちゃや離乳食用品の整理に',
    },
    {
      id: 's7',
      name: '歯ブラシ・歯ケアグッズ',
      priority: 'should',
      timing: '6ヶ月頃〜',
      priceYenMin: 1000,
      priceYenMax: 3000,
      note: '乳歯が生え始めたら開始',
    },
    {
      id: 's8',
      name: 'ベビーフードや離乳食食材',
      priority: 'should',
      timing: '5〜6ヶ月頃',
      priceYenMin: 2000,
      priceYenMax: 6000,
      note: '初期は少量から。アレルギー確認を',
    },
    {
      id: 's9',
      name: 'ベビーゲート・セーフティグッズ',
      priority: 'should',
      timing: '8〜12ヶ月頃',
      priceYenMin: 3000,
      priceYenMax: 15000,
      note: 'はいはい・つかまり立ちに合わせて',
    },
    {
      id: 's10',
      name: '絵本',
      priority: 'nice',
      timing: '3〜12ヶ月',
      priceYenMin: 1000,
      priceYenMax: 5000,
      note: '布絵本やボードブックから',
    },
    {
      id: 's11',
      name: 'ママ用バッグ・リュック',
      priority: 'nice',
      timing: '3〜12ヶ月',
      priceYenMin: 3000,
      priceYenMax: 12000,
      note: 'お出かけ用に両手が空くリュックも便利',
    },
    {
      id: 's12',
      name: 'おむつ（M・Lサイズ）',
      priority: 'must',
      timing: '3〜12ヶ月',
      priceYenMin: 4000,
      priceYenMax: 12000,
      note: '成長に合わせてサイズアップ',
    },
  ],
  warnings: [
    { id: 'w1', label: '高熱けいれん', level: 'urgent' },
    { id: 'w2', label: '意識異常', level: 'urgent' },
    { id: 'w3', label: '呼吸異常', level: 'urgent' },
    { id: 'w4', label: '発達チェック・成長曲線', level: 'watch' },
    { id: 'w5', label: '食欲の低下', level: 'watch' },
    { id: 'w6', label: 'ママの気分の落ち込み・消耗', level: 'watch' },
    { id: 'w7', label: '離乳食のアレルギー反応', level: 'watch' },
    { id: 'w8', label: '発熱（38度以上）', level: 'watch' },
  ],
  partner: [
    { id: 'p1', text: '育児の役割を再確認する' , detail: '離乳食・保育園・仕事復帰に向け、役割を見直して書き換える。'},
    { id: 'p2', text: '夫婦の時間を意識してつくる' , detail: '夫婦の短いデートや会話の時間を予定に入れる。'},
    { id: 'p3', text: 'ママの休息を継続してサポートする' , detail: 'ママの休息を「特別」ではなく日常の分担として続ける。'},
    { id: 'p4', text: '離乳食や沐浴を一緒に行う' , detail: '離乳食づくりや沐浴を週の担当表にする。'},
    { id: 'p5', text: '保育園や復職の計画を一緒に進める' , detail: '保育園見学や復職スケジュールを一緒に進め、書類期限を共有。'},
    { id: 'p6', text: '予防接種や健診に同行する' , detail: '健診・予防接種に同行し、質問メモを分担する。'},
    { id: 'p7', text: 'ママの様子を観察し、相談を促す' , detail: 'ママの様子が気になるときは責めず、相談先を一緒に探す。'},
    { id: 'p8', text: '二人の時間を短くても作る' , detail: '子どもが寝たあと10分でも二人の時間をつくる。'},
  ],
  tips: [
    {
      id: 't1',
      title: '離乳食は「少量・単品」から',
      body: '生後5〜6ヶ月頃、なめらかにすりつぶした状態（10倍がゆ等）から。月齢に合わせて舌でつぶせる→歯ぐきでつぶせる固さへ。初めは1さじ、3〜5日様子を見ます。',
    },
    {
      id: 't2',
      title: '予防接種は予約が取りにくいことがある',
      body: 'BCGやロタなど、接種可能時期が決まっているものは早めに予約。母子手帳のスケジュールを確認し忘れないようにしましょう。',
    },
    {
      id: 't3',
      title: '復職・保育園は早めに情報収集',
      body: '保育園の申込み時期や認可・認可外の違いを自治体HPで確認。新潟市では子育て応援パンフ「SKIP」に園一覧・遊び場マップがあります（自治体により異なります）。',
    },
    {
      id: 't4',
      title: '夫婦の時間は「長さ」より「質」',
      body: '15分でも食事を一緒にする、お風呂上がりに話すなど小さな接点を大切に。育児の分担も定期的に見直しましょう。',
    },
    {
      id: 't5',
      title: '事故予防は月齢ごとに見直し',
      body: '誤飲・転落・浴槽・チャイルドシート（6歳未満は着用義務）を定期チェック。うつ伏せ寝や受動喫煙はSIDSリスクを高めるため避けましょう。',
    },
    {
      id: 't6',
      title: '迷ったら#8000',
      body: '休日・夜間に受診すべきか迷ったら、こども医療電話相談#8000で看護師等に相談できます（新潟市などの例）。',
    },
    {
      id: 't7',
      title: '1歳未満にハチミツはNG',
      body: '乳児ボツリヌス症予防のため、はちみつやはちみつ入り食品は1歳まで与えないでください。',
    },
  ],
  adminGuide: [
    {
      id: 'a1',
      title: '保育園の申込み',
      body: '認可保育園は自治体への申込みが必要。申込み時期や入所基準、必要書類を確認し、見学も併せて計画しましょう。新潟市はSKIP等の案内も参考に（自治体により異なります）。',
      when: '産後3〜6ヶ月頃から',
    },
    {
      id: 'a2',
      title: '育休からの復職手続き',
      body: '復職日の3〜4週間前には会社へ連絡。勤務時間・休憩・短時間勤務など働き方を調整。両親で取得する場合はパパママ育休プラス（子が1歳2か月まで延長できる制度）も確認を。',
      when: '復職1〜2ヶ月前',
    },
    {
      id: 'a3',
      title: '扶養控除・税務手続き',
      body: '年末調整や確定申告で、扶養控除や医療費控除が使える場合があります。領収書や母子手帳の控えを整理しておきましょう。',
      when: '年末調整・確定申告期',
    },
    {
      id: 'a4',
      title: '予防接種の予診票',
      body: '母子手帳に記載されたスケジュールに沿って接種。任意接種の費用や時期も確認し、小児科で相談しましょう。',
      when: '1〜12ヶ月頃',
    },
    {
      id: 'a5',
      title: '児童手当の継続手続き',
      body: '中学校3年生まで継続。所得や転居などで変更があった場合は、自治体へ届出が必要です。',
      when: '変動があったら随時',
    },
    {
      id: 'a6',
      title: '乳児一般健康診査',
      body: '3〜4ヶ月・10ヶ月（乳児一般健診I・II）、1歳6ヶ月、3歳などで発育・発達を確認。離乳食や育児の相談もできます（新潟市の例／自治体により異なります）。',
      when: '該当月齢',
    },
    {
      id: 'a7',
      title: 'こども医療費助成',
      body: '子どもの医療費（保険診療分）の自己負担を助成する制度。出生後の加入後も転居・保険変更時は届出を（新潟市の例）。',
      when: '随時・変更時',
    },
    {
      id: 'a8',
      title: 'ファミリー・サポート・センター',
      body: '子育ての手助けをしてほしい人と手伝いたい人を結ぶ有償ボランティア。送迎や預かりに利用できます（新潟市の例）。',
      when: '保育が必要になったとき',
    },
    {
      id: 'a9',
      title: '一時預かり・ショートステイ',
      body: 'リフレッシュ・病気・冠婚葬祭などで一時的に預けるサービス。宿泊型のショートステイ（子育て短期支援）もあります（自治体により異なります）。',
      when: '必要時',
    },
    {
      id: 'a10',
      title: '新潟県こむすび定期',
      body: '新潟県内で生まれた1歳未満の子どもが対象。10万円の定期預金を支給。1歳の誕生日前日までに県の電子申請システムから申請。',
      when: '1歳の誕生日前日まで',
    },
    {
      id: 'a11',
      title: '子ども医療電話相談（#8000）',
      body: '休日・夜間に子どもの病気やけがで受診すべきか迷った時に、看護師等へ相談できます（新潟市などの例）。',
      when: '緊急時・休日夜間',
    },
  ],
  careScenes: [
    {
      id: 'cs1',
      title: '離乳食',
      items: [
        '食器・エプロン・スプーンを準備する',
        '最初は1さじから、単品で3〜5日様子を見る',
        'アレルギー食材は少量ずつ導入',
        '食べ残しても無理に食べさせない',
        '食後に水分補給を忘れずに',
      ],
    },
    {
      id: 'cs2',
      title: 'お出かけ',
      items: [
        'おむつ・おしり拭き・着替えを多めに',
        '授乳スペースやベビールームのある施設を選ぶ',
        '外出時間はママと赤ちゃんの調子に合わせる',
        'ママ自身の水分と休息も確保',
        '人混みや長時間移動は避ける',
      ],
    },
    {
      id: 'cs3',
      title: '夜の寝かしつけ',
      items: [
        '部就寝の前にゆっくりした時間を作る',
        'お風呂・授乳・歯磨きの流れを固定化',
        '夜泣きはすぐに対応せず、少し様子を見ることも',
        '寝室は暗く、適温に保つ',
        'ママも無理せず一緒に休む',
      ],
    },
    {
      id: 'cs4',
      title: '遊び・刺激',
      items: [
        'おしゃべりや歌を日常に取り入れる',
        '布絵本や音のなるおもちゃで五感を育む',
        'うつ伏せ遊び（tummy time）は見守りながら短時間',
        '外の空気や緑を感じる時間を作る',
        '成長に合わせて安全な環境を整える',
      ],
    },
  ],
  exercises: [
    {
      id: 'ex1',
      title: '産後リカバリーワークアウト（15分）',
      durationMin: 15,
      url: 'https://www.youtube.com/watch?v=zmUJWKM98hM',
      channel: '妊娠・産後エクササイズチャンネル',
      note: '産後の回復に合わせて無理なく。骨盤底筋を意識しながら、ゆっくりと体を動かしましょう。',
      level: 'gentle',
    },
    {
      id: 'ex2',
      title: '産後ヨガフロー（20分）',
      durationMin: 20,
      url: 'https://www.youtube.com/watch?v=feHp2b29G5U',
      channel: '妊娠・産後エクササイズチャンネル',
      note: '体力が戻ってきたら少し長めのフローに挑戦。自分のペースで休憩を入れながら。',
      level: 'moderate',
    },
    {
      id: 'ex3',
      title: 'アドリエンのやさしい産後ヨガ',
      durationMin: 22,
      url: 'https://www.youtube.com/watch?v=-3bvlFKeLRE',
      channel: 'アドリエンのヨガ',
      note: 'やさしいヨガで心と体を整えます。産後の回復ペースは人それぞれ。焦らず続けましょう。',
      level: 'gentle',
    },
  ],
};

